import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// project import
import { APP_DEFAULT_PATH, USER_ROLE } from "utils/Constants";
import useAuth from "hooks/useAuth";

// types
import { GuardProps } from "types/auth";

// ==============================|| GUEST GUARD ||============================== //

const GuestGuard = ({ children }: GuardProps) => {
  const { isLoggedIn, twoFactorAuth, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn) {
      if (user && user.two_factor_enabled) {
        navigate(
          user && user.role === USER_ROLE.ADMIN ? "/admin/users" : "/stores"
        );
      } else {
        navigate("/my-profile?tab=configure-2fa");
      }
    }
  }, [isLoggedIn, twoFactorAuth]); // Removed navigate and location from the dependency array

  return children;
};

export default GuestGuard;
